export default {
  "outdoor": "Наружка"
}
